import { z } from 'zod';
import { DataOriginSchema } from './common';
import { ReviewStatusSchema } from './research';

export const DraftDocumentSchema = z.object({
  id: z.string(),
  dataOrigin: DataOriginSchema,
  title: z.string(),
  kind: z.enum(['memo', 'letter', 'clause', 'opinion']),
  reviewStatus: ReviewStatusSchema,
  updatedAt: z.string(),
  body: z.string(),
});
export type DraftDocument = z.infer<typeof DraftDocumentSchema>;

export const StudyTopicSchema = z.object({
  id: z.string(),
  dataOrigin: DataOriginSchema,
  subject: z.string(),
  title: z.string(),
  summary: z.string(),
  progress: z.number().min(0).max(100),
});
export type StudyTopic = z.infer<typeof StudyTopicSchema>;

export const QuizQuestionSchema = z.object({
  id: z.string(),
  prompt: z.string(),
  options: z.array(z.object({ id: z.string(), text: z.string() })).min(2),
  correctOptionId: z.string(),
  explanation: z.string(),
  citationIds: z.array(z.string()),
});
export type QuizQuestion = z.infer<typeof QuizQuestionSchema>;

export const QuizSchema = z.object({
  id: z.string(),
  dataOrigin: DataOriginSchema,
  topicId: z.string(),
  title: z.string(),
  questions: z.array(QuizQuestionSchema).min(1),
});
export type Quiz = z.infer<typeof QuizSchema>;

/** Editorial workflow states (LEGAL-KNOWLEDGE-ENGINE.md). */
export const EditorialStatusSchema = z.enum([
  'registered',
  'acquired',
  'extracted',
  'review_ready',
  'under_review',
  'approved_for_defined_use',
  'provisional',
  'rejected',
  'needs_more_evidence',
]);
export type EditorialStatus = z.infer<typeof EditorialStatusSchema>;

export const EditorialTaskSchema = z.object({
  id: z.string(),
  dataOrigin: DataOriginSchema,
  sourceId: z.string(),
  title: z.string(),
  dimension: z.enum(['authenticity', 'text_integrity', 'legal_status', 'legal_analysis']),
  status: EditorialStatusSchema,
  assigneeLabel: z.string(),
  priority: z.enum(['low', 'normal', 'high']),
  updatedAt: z.string(),
});
export type EditorialTask = z.infer<typeof EditorialTaskSchema>;
